import React from "react";

export default function HamburgerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="34"
      viewBox="0 0 39 34"
    >
      <g
        id="Group_1062"
        data-name="Group 1062"
        transform="translate(-5273 1715)"
      >
        <g id="Header" transform="translate(5273 -1715)">
          <rect
            id="Rectangle_96"
            data-name="Rectangle 96"
            width="39"
            height="7"
            rx="3"
            fill="#fb487b"
            stroke="black"
            background="black"
          />
          <rect
            id="Rectangle_98"
            data-name="Rectangle 98"
            width="39"
            height="7"
            rx="3"
            transform="translate(0 18)"
            fill="#b974f3"
            stroke="black"
          />
          <rect
            id="Rectangle_99"
            data-name="Rectangle 99"
            width="39"
            height="7"
            rx="3"
            transform="translate(0 9)"
            fill="#e55abd"
            stroke="black"
          />
          <rect
            id="Rectangle_100"
            data-name="Rectangle 100"
            width="39"
            height="7"
            rx="3"
            transform="translate(0 27)"
            fill="#00c3ee"
            stroke="black"
          />
        </g>
      </g>
    </svg>
  );
}
